import { css } from '@emotion/react';
import getConfirmationModalStyles from './_confirmation-modal.css';
import getFileFieldStyles from './_file-field.css';
import getFileInputStyles from './_file-input.css';
import getItemDetailsStyles from './_item-details.css';
import getLoaderStyles from './_loader.css';
import getNavMenuStyles from './_nav-menu.css';
import getUweentityAssignmentsStyles from './_uweentity-assignments.css';
import getUweentityHistoryStyles from './_uweentity-history.css';
import getUweentityNotesStyles from './_uweentity-notes.css';
import getUweentityProgressStyles from './_uweentity-progress.css';
import getWaitForUweentityFilesStyles from './_wait-for-uweentity-files.css';
import getIntegrationUserStyles from './_integration-user.css';
import getSignatureFieldStyles from './_signature-field.css';
import getEntityEditorStyles from './_entity-editor.css';
import getUweSidebarpanelFormStyles from './_uwe-sidebarpanel-form.css';
import getInteractiveDrawingStyles from './_interactive-drawing.css';
import getSwitchStyles from './_switch.css';
import getFormComparisonStyles from './_form-comparison.css';
import getSelectImageFieldStyles from './_select-image-field.css';
import getOrganizationalUnitTreeNodeStyles from './_organizational-unit-tree-node.css';
import getCollapsableTreeSelectStyles from './_collapsable-tree-select.css';
import getButtonBarStyles from './_button-bar.css';
import getWorkflowBuilderStyles from './_workflow-builder';
import getLookupListFieldStyles from './_lookup-list-field.css';

const styles = [
  getConfirmationModalStyles,
  getFileFieldStyles,
  getFileInputStyles,
  getItemDetailsStyles,
  getLoaderStyles,
  getNavMenuStyles,
  getUweentityAssignmentsStyles,
  getUweentityHistoryStyles,
  getUweentityNotesStyles,
  getUweentityProgressStyles,
  getWaitForUweentityFilesStyles,
  getIntegrationUserStyles,
  getSignatureFieldStyles,
  getEntityEditorStyles,
  getUweSidebarpanelFormStyles,
  getInteractiveDrawingStyles,
  getSwitchStyles,
  getFormComparisonStyles,
  getSelectImageFieldStyles,
  getOrganizationalUnitTreeNodeStyles,
  getCollapsableTreeSelectStyles,
  getButtonBarStyles,
  getWorkflowBuilderStyles,
  getLookupListFieldStyles,
];

export default $ => css(styles.map(style => style($)));
